module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOTBjNmFiM2NmMDg5NDE5NTNhOGQwZGEwYzk3Y2Q3NjkucG5nIjs="